import { __rest } from 'tslib';
import React__default from 'react';
import { CommonStyles } from '../BaseProps/index.es.js';
import { BREAK_POINTS } from '../Grid/constant.es.js';
import styled from '@emotion/styled';
import { pixelParse } from '../../helpers/utils.es.js';

const Wrapper = styled.div `
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${BREAK_POINTS.xl}) {
    width: ${(props) => (props.fluid ? '100%' : pixelParse(props.maxWidth))};
  }
  ${CommonStyles}
`;
const Container = React__default.forwardRef((props, ref) => {
    const { children, fluid = false, maxWidth = 1232 } = props, others = __rest(props, ["children", "fluid", "maxWidth"]);
    return (React__default.createElement(Wrapper, Object.assign({ maxWidth: maxWidth, fluid: fluid, ref: ref }, others), children));
});
Container.displayName = 'Container';

export { Container };
